import { combineReducers } from '@reduxjs/toolkit';

import navigationTabs from './navigation-tabs/reducers';
import nextVideo from './next-video/reducers';
import upload from './upload/reducers';
import conversion from './stream-conversion/reducers';
import cutting from './cutting/reducers';
import clipDownload from './clip-download/slice';
import drm from './drm/slice';

export default combineReducers({
    navigationTabs,
    nextVideo,
    upload,
    conversion,
    cutting,
    [clipDownload.name]: clipDownload.reducer,
    [drm.name]: drm.reducer,
});
